export default __webpack_public_path__ + "static/media/settings-ethernet.2def48d0.svg";